import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const Services = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((res) => setServices(res.data)).catch(() => {});
  }, []);

  return (
    <section
      id="diensten"
      data-testid="services-section"
      className="py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <span className="text-[#FF1A1A] text-sm font-semibold tracking-[0.25em] uppercase">
            Diensten
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-5 leading-tight">
            Compleet in renovatie <br /> en afwerking.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Wrench;
            return (
              <motion.div
                key={s.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08, ease: "easeOut" }}
                data-testid={`service-card-${i}`}
                className="bg-[#111111] p-7 border border-white/5 group hover:-translate-y-2 hover:border-white/15 transition-all duration-300 cursor-default flex flex-col gap-4"
              >
                <Icon
                  className="text-white/70 group-hover:text-[#FF1A1A] transition-colors"
                  size={36}
                  strokeWidth={1.3}
                />
                <div className="relative pb-2 inline-block w-max">
                  <h3 className="font-heading text-lg font-semibold text-white">
                    {s.title}
                  </h3>
                  <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-[#FF1A1A] group-hover:w-full transition-all duration-300" />
                </div>
                <p className="text-sm text-white/55 font-light leading-relaxed">
                  {s.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
